// /api/timer/ — the logged-in member's running timer (api/timer_views.py).
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const timerUrl = () => `${API_BASE_URL}timer/`;

export const fetchRunningTimer = async () => {
  const response = await axios.get(timerUrl());
  return response.data?.timer ?? null;
};

// 409 means one is already running (another tab/browser) — the caller adopts it.
export const startRunningTimer = async ({ teamspaceId, startTime, formData }) => {
  try {
    const response = await axios.post(timerUrl(), {
      teamspace_id: Number(teamspaceId),
      start_time: startTime,
      form_data: formData,
    });
    return { timer: response.data.timer, conflict: false };
  } catch (err) {
    if (err.response?.status === 409) return { timer: err.response.data.timer, conflict: true };
    throw err;
  }
};

// 409: someone saved a newer version first. 404: it was stopped elsewhere.
export const updateRunningTimer = async ({ teamspaceId, formData, version }) => {
  try {
    const response = await axios.patch(timerUrl(), {
      teamspace_id: Number(teamspaceId),
      form_data: formData,
      version,
    });
    return { timer: response.data.timer, conflict: false, notRunning: false };
  } catch (err) {
    if (err.response?.status === 409) return { timer: err.response.data.timer, conflict: true, notRunning: false };
    if (err.response?.status === 404) return { timer: null, conflict: false, notRunning: true };
    throw err;
  }
};

// 404: already stopped — by another tab's Cancel or Save & Stop.
export const stopRunningTimer = async () => {
  try {
    const response = await axios.delete(timerUrl());
    return { timer: response.data.timer, notRunning: false };
  } catch (err) {
    if (err.response?.status === 404) return { timer: null, notRunning: true };
    throw err;
  }
};
